module.exports = __webpack_public_path__ + "img/logo-icrea-white-menu.baf59199.svg";